const english = {
  //header
  home: 'Home',
  aboutUs: 'About Us',
  ourTemplates: 'Our Templates',
  createaStunningwebsite: 'Create a stunning website for your personal, professional, or business needs with over 5,000+ website templates.',
  ourMission: 'Our Mission',
  helpCenter: 'Help Center',
  unread: 'Read',
  markRead: 'Mark Read',
  noNotifications: 'No notifications',
  accountSetting: 'Account Setting',
  myOrder: 'My Order',
  enquires: 'Enquires',
  manageYourTemplate: 'Manage Your Template',
  signOut: 'Sign Out',
  logIn: 'Login',
  getStarted: 'Get Started',

  //Home
  getProfessionalWebsiteFor: "Get a Professional Website for the Price of a Cup of Tea!",
  justAt: "Just at",
  perDay: "per day",
  playVideo: "Play Video",
  madeInIndia: "Made in India",
  forThePeopleOfIndia: "For the people of India",
  wideSelectionOfTemplates: "Wide selection of templates according to your",
  withOverProfessionBusiness: "With over 4950+ profession/business templates, create the perfect website that caters to your niche",
  howToCreateStunningWebsiteWithUs: "How to create stunning website with us",
  beItCvorProfessionalLookingWebsite: "Be it a CV or professional looking website, you can now create stunning websites using our templates which optimized to your needs. For more info check out our video",
  watchVideo: "Watch Video",
  why: "Why",
  india: "India",
  appIsTheBest: "App is the best choice for you",
  digital: "Digital",
  my: "My",
  creatingProfessionalAndVisually: "Creating a professional and visually appealing website has never been easier. At MyDigitalIndia app, we strive to provide you with the best tools and services to make your website stand out.",
  realTimeContentUpdates: "Real-time Content Updates",
  updateYourWebsiteContentAnytime: "Update your website’s content anytime with ease.",
  instantContactNotifications: "Instant Contact Notifications",
  receiveImmediateInboxAlertsForEvery: "Receive immediate inbox alerts for every customer inquiry.",
  aIPoweredMarketing: "AI Powered Marketing",
  enjoyBestAutomatedMarketingThrough: "Enjoy best, automated marketing through AI technology.",
  easyCancellationPolicy: "Easy Cancellation Policy",
  cancelAnytimeWithSeamlessHassle: "Cancel anytime with a seamless, hassle-free process.",
  superiorPerformanceAndSpeed: "Superior Performance and Speed",
  experienceFastLoadingTimesForAn: "Experience fast loading times for an engaging user experience.",
  seoOptimizedDesign: "SEO - Optimized Design",
  improveYourSearchEngineRankings: "Improve your search engine rankings with built in SEO features.",
  enterpriseGradeSecurity: "Enterprise-Grade Security",
  protectYourSiteWithAdvanced: "Protect your site with advanced, enterprise-level security.",
  reliableMultiCloudHosting: "Reliable Multi-Cloud Hosting",
  ensureUptimeEvenDuringTrafficSpikes: "Ensure 99.9% uptime even during traffic spikes with multi-cloud hosting",
  weGotYouCoveredWithEssentialsYouNeed: "We got you covered with essentials you need for digital success",
  weMakeSureThatYouGetAllTheMustHaveFeatures: "We make sure that you get all the must have features to start and boost your online journey to a new level.",
  templates: "Templates",
  ourMission: "Mission",
  OurMission: "Our Mission",
  showcase: 'Showcase',
  atMyDigitalIndiaOurMissionIsToDigitizeIndia: "At MyDigitalIndia, our mission is to digitize India in alignment with the Prime Minister’s Digital India initiative. We strive to provide every professional and business owner with an affordable and powerful online presence, enabling them to reach a wider audience.  By offering a wide range of high-quality website templates at the most affordable rates, we aim to make digital accessibility a reality for all.",
  shriNarendraModi: "Shri Narendra Modi",
  honblepmOfIndia: "Hon’ble PM of India",
  khushbuBhati: "Khushbu Bhati",
  founder: "Founder",
  testimonials: "Testimonials",
  discoverHowMyDigitalIndiaApp: "Discover how MyDigitalIndia App has transformed the online presence of businesses just like yours. Our customers' success stories highlight the ease of use, exceptional features and top-notch support that have made us a trusted choice for professionals and businesses across India.",
  akritiDubey: "Akriti Dubey",
  charteredAccountant: "Chartered Accountant",
  connectWithUsNowAndStartYourJourney: "Connect with us now and start your journey towards digital success.",
  haveAQuestion: "Have a question?",
  clear:"Clear",

  //footer
  atMyDigitalIndiaWeAreDedicated: "At MyDigitalIndia, we are dedicated to empowering professionals and businesses with the tools they need to establish a strong online presence. As pioneers in offering affordable and versatile website templates in India, we take pride in our user-friendly platform and exceptional customer service.",
  pages: "Pages",
  blogs: "Blogs",
  termsAndConditions: "Terms and Conditions",
  privacyPolicy: "Privacy Policy",
  help: "Help",
  contactUs: "Contact Us",
  access: "Access",
  signIn: "Sign In",

  //About us
  atMyDigitalIndiaWeAreCommittedToProviding: "At MyDigitalIndia, we are committed to providing everyone with a remarkable and professional online presence, regardless of their technical skills or background. Whether you're a business, an entrepreneur, a professional, or simply someone looking to create a personal website, our goal is to empower you to design beautiful, functional websites with ease. Our user-friendly services ensure a seamless experience for all, no matter your age or purpose.",
  whoWeAre: "Who we are",
  foundedByDedicatedTeamOfTechEnthusiasts: "Founded by a dedicated team of tech enthusiasts and design experts, MyDigitalIndia is on a mission to revolutionize India's digital landscape. Our founders recognized the challenges faced by individuals, small businesses, and entrepreneurs in establishing a professional online presence without high costs or technical expertise. MyDigitalIndia was created to bridge this gap by providing comprehensive web solutions tailored for everyone, whether for personal, professional, or business use.",
  meetOurFounder: "Meet Our Founder",
  mrsKhushbuBhatiTheVisionary: "Mrs. Khushbu Bhati, the visionary behind MyDigitalIndia, is a passionate advocate for digital empowerment and accessibility. With a strong background in technology and design, Mrs. Bhati has always been driven by the desire to make high-quality web solutions accessible to all.",
  ourVision: "Our Vision",
  ourVisionIsDigitallyEmpowered: "Our vision is a digitally empowered India where everyone—from individuals to businesses, big or small—can thrive online. With our affordable and comprehensive web solutions, we aim to bridge the digital gap and fuel growth across the country. We are committed to providing the tools and resources necessary for success in the digital age, contributing to a dynamic and inclusive digital economy for all.",
  joinUs: "Join Us",
  becomePartofTheMyDigitalIndiaCommunity: "Become a part of the MyDigitalIndia community and take   the first step towards building a strong online presence. Whether you're an individual, small business owner, or freelancer, we’re here to support your journey. Let’s work together to create a digital future that’s inclusive, innovative, and aligned with the vision of a Digital India!",
  signUp: "Sign Up",


  //My Account
  myAccount: "My Account",
  hereYouCanManageAllYourAccount: "Here you can manage all your account details, subscription and renewal.",
  accountDetails: "Account Details",
  fullName: "Full Name",
  email: "Email",
  contact: "Contact",
  haveYouForgetYourPassword: "Have you forget your password?",
  resetPassword: "Reset Password",
  savedPayments: "Saved Payments",
  debitCardCreditCard: "Debit Card/ Credit Card",
  subscription: "Subscription",
  youHaveBeenSubscribed: "You have been subscribed to our yearly plan.",
  startDate: "Start Date",
  endDate: "End Date",
  yourSubscriptionEndingSoon: "Your Subscription ending soon?",
  renewNow: "Renew Now",
  doYouWishToCancelYourSubscription: "Do you wish to cancel your subscription?",
  WhenYourRemainingDaysLessThan: "You can renew when you have less than 60 days remaining.",
  yourSubscriptionHasBeenCanceled: "Your subscription has been canceled. You will retain access until the end of your billing period.",
  cancelSubscription: "Cancel Subscription",
  deleteAccount: "Delete Account",
  areYouSureYouWantToDelete: "Are you sure you want to delete your account? This action cannot be undone.",
  cancel: "Cancel",
  confirm: "Confirm",
  otherSettings: "Other Settings",
  doYouWishToDeleteYourAccount: "Do you wish to delete your account?",
  areYouSureYouWantToCancelYourSubscription: "Are You Sure You Want To Cancel Your Subscription.",


  renewSubscription: "Renew Subscription",
  readyToRenewYourSubscriptionEnsureContinuousService: "Ready to Renew Your Subscription? Ensure Continuous Service! Stay connected and keep your website running smoothly by renewing today. Don’t miss out on the full range of features and benefits from MyDigitalIndia.",
  billingDetails: "Billing Details",
  yourName: "Your Name",
  gstin: "GSTIN",
  optional: "Optional",
  day: "day",
  getCuttingEdgeAIDrivenMarketingDesigned: "Get cutting-edge AI-driven marketing designed to optimize and enhance your digital marketing strategy",
  selectedYourDomain: "Selected your domain",
  youHaveSelectedPremiumDomain: "You have selected a premium domain. You will be charged Rs",
  basePrice: "Base Price",
  yearly: "Yearly",
  days: "days",
  premiumDomain: "Premium Domain",
  addOn: "Add on",
  aiMarketing: "Ai Marketing",
  total: "Total",
  checkout: "Checkout",
  rs: "Rs",

  //myOrders
  myOrders: "My Orders",
  hereYouCanManageAllYourOrders: "Here you can manage all your orders.",
  orderNo: "Order no",
  dateOfPublish: "Date of Publish",
  domainName: "Domain Name",
  dateOfRenewal: "Date of Renewal",
  view: "View",
  printReceipt: "Print Receipt",
  downloadReceipt: "Download Receipt",

  //Enquires
  enquires: "Enquires",
  wishlist: "Wishlist",
  manageAllYourInquiresReceived: "Manage all your inquires received via contact form.",
  enquiry: "Enquiry",
  name: "Name",
  mobileNo: "Mobile No.",
  message: "Message",

  manageYourTemplates: "Manage Your Templates",
  hereYouCanManageUptoTemplates: "Here you can manage upto 5 templates with ease. Whether you're looking to update, customize or switch templates, this page provides all the necessary options.",
  desktop: "Desktop",
  mobile: "Mobile",
  doYouWishSwitchThisTemplate: "Do you wish to switch this template?",
  currentThemeWeillBeSwitched: "Current theme weill be switched to new selected to new selected theme. All the data from current theme will be transferd to new theme.",
  newTheme: "New Theme",
  change: "Change",
  switch: "Switch",
  selectNewTheme: "Select New Theme",
  currentTheme: "Current Theme",
  domain: "Domain",
  draft: "Draft",
  underReview: "Under Review",
  published: "Published",
  inactive: "Inactive",
  editWebsite: "Edit Website",
  publish: "Publish",
  preview: "Preview",
  switchTemplate: "Switch Template",
  doYouWantToPublishThisTemplate: "Do you want to publish this template?",
  theSelectedThemeWillBeApplied: "The selected theme will be applied. No data will be transferred from the previous theme. If you want to transfer the data, click on",


  edit: "Edit",
  all: "All",
  typeYourNiche: "Type your niche",

  //Edit website
  createAWebsiteThatsUniquelyYours: "Create a website that's uniquely yours! Fill out the following details! Use our show/hide toggle switches to easily select the sections you want. Personalize every aspect and bring your vision to life with just a few clicks.",
  back: "Back",
  personalInformation: "Personal Information",
  companyName: "Company Name",
  companyTagline: "Company Tagline",
  enterYouName: "Enter you name",
  enterYouCompanyName: "Enter you company name",
  enterYouCompanyTagline: "Enter you company Tagline",
  profession: "Profession",
  enterSelfDescribes: "Enter self describes",
  phone: "Phone",
  enterNumber: "Enter number",
  enterEmail: "Enter email",
  address: "Address",
  address1: "Address 1",
  address2: "Address 2",
  social: "Social",
  workingHours: "Working Hours",
  openTime: "Open time",
  closeTime: "Close time",
  uploadProfileImage: "Upload Profile image",
  uploadYourBannerImage: "Upload your banner image",
  upload: "Upload",
  sizeShouldBeLessThan: "Size should be less than 5mb",
  uploadLogo: "Upload logo",
  uploadYourLogo: "Upload your logo",
  selectImage: "Select Image",
  uploadBannerImage: "Upload banner image",
  fileResolutionIsGreaterThen: "File resolution is greater then 1900*1280",
  imageVideo: "Image/Video",
  aboutMedia: "About Media",
  selectMedia: "Select Media",
  about: "About",
  heading: "Heading",
  aboutDescription: "About Description",
  reset: "Reset",
  portfolio: "Portfolio",
  enterTitle: "Enter Title",
  description: "Description",
  title: "Title",
  externalLink: "External Link",
  image: "Image",
  addMore: "Add More",
  addProfessionalSkills: "Add Professional Skills",
  skill: "Skill",
  percentage: "Percentage",
  addServices: "Add Services",
  serviceDescription: "Service Description",
  addEducation: "Add Education",
  universityInstituteName: "University/Institute name",
  degree: "Degree",
  course: "Course",
  addWorkExperience: "Add Work Experience",
  jobProfile: "Job Profile",
  workingyear: "Working year",
  addProducts: "Add Products",
  price: "Price",
  addPricingPlans: "Add Pricing Plans",
  subHeading: "Sub heading",
  buttonText: "Button text",
  features: "Features",
  addIncrement: "Add Increment",
  counterNumber: "Counter number",
  addTestimonials: "Add Testimonials",
  teamMembers: "Team Members",
  designation: "Designation",
  addBlog: "Add Blog",
  externalLink: "External link",
  addAchievement: "Add Achievement",
  addReference: "Add reference",
  comment: "Comment",
  sorryAnUnexpectedErrorHasOccurred: "Sorry, an unexpected error has occurred",
  tryAgain: "Try Again",
  savePreview: "Save & Preview",
  save: "Save",
  yourProgressHasBeenSaved: "Your progress has been saved",
  addVideos: "Add Videos",
  video: "Video",
  update: "Update",
  domainSetup: "Domain Setup",
  choosingTheRightDomainNameIsTheFirstStep: "Choosing the right domain name is the first step towards establishing a strong online presence. At MyDigitalIndia, we make it easy for you to find and register the perfect domain that reflects your brand and is easy for your customers to remember.",
  instructionVideo: "Instruction Video",
  checkoutPage: "Checkout Page",
  thankYouForChoosingMyDigitalIndia: "Thank you for choosing MyDigitalIndia! Please review the details of your order below. Ensure all information is correct before proceeding to checkout.",
  yourOrderHasBeenConfirmed: "Your Order has been confirmed",
  thankYouForChoosing: "Thank you for choosing MyDigitalIndia",
  weAreThrilledToHaveYouOnBoard: "We are thrilled to have you on board and are excited to help you create a stunning online presence.",
  orderSummary: "Order Summary",
  summary: "Summary",
  planDetails: "Plan Details",
  noteItWillTakeDaysForYourWebsiteToGetPublished: "Note: It will take 5-10 days for your website to get published for the first time. Thank you for your patience.",
  welcomelogin: "Welcome!",
  greatToseeu: "Great to see you! Easily manage your website on the go—quick and simple.",
  enterUrmail: "Enter your Email :",
  enterUrmobi: "Enter your Mobile no",
  passworD: "Password :",
  continue: "Continue",
  forgotPass: "Forget your password? ",
  clikhere: "Click here",
  loginmobi: "Signup with Mobile",
  logingoog: "Signup with Google",
  loginaple: "Signup with Apple",
  loginmail: "Signup with Email",
  donthavAccount: "Don’t have an account yet?",
  dontwrry: "Don’t worry. We got you covered.",
  reseopt: "Resend OTP",
  backttop: "Back to Login Page",
  createanacc: "Create an account",
  getaccessto: "Get access to our wide variety of templates and start your digital journey today!",
  alreadyacc: "Already have an account?",
  availtodownload: "Available to download :",
  contacus: "Contact Us",
  contacdescp: "At MyDigitalIndia, your success is our priority. Whether you have a question, need assistance or want to provide feedback, we’re here to support you every step of the way. Our dedicated team is ready to assist you with any inquiries and ensure you have the best experience possible.",
  get24suppo: "Get 24/7 Support",
  youcanaskcontac: "You can ask questions, watch tutorials or browse articles about any queries, anytime & anywhere.",
  prefermailreac1: "Prefer to send us an email? Reach out to us at",
  prefermailreac2: "and we’ll get back to you within 24 hours.",
  livchat: "Live Chat",
  connecwithus1: "Connect with us instantly through our live chat feature. Our customer support representatives are available from",
  connecwithus2: "to provide immediate assistance.",
  contacform: "Contact Form",
  fillouteasy: "Fill out our easy-to-use contact form below, and we’ll respond promptly. Provide us with as much detail as possible so we can address your inquiry effectively.",
  submit: "Submit",
  fistnam: "First Name",
  lasnam: "Last Name",
  mobinumber: "Mobile Number",
  messaGe: "Message",
  folowUs: "Follow Us",
  joinurvibrantcomm: "Join our vibrant community and stay updated with the latest news, updates, and trends in the digital world. By following us on social media, you'll be the first to know about new features, exciting offers, expert tips, and much more.",

  editThisTemplate: " Edit This Template",
}

export default english;